module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-Regular-55063c50a766343617f716f1be51da55.woff2";